const itemsSocial = (state) =>
  state.redesSociales
    .map(
      (itemSocial) =>
        `<li id="${itemSocial.name}"><a href="${itemSocial.url}" target="_blank" rel="noopener">${itemSocial.icon}</a></li>`
    )
    .join('')
export default itemsSocial
